import gsap from "gsap";

class HeroA16ZLive {

    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.neonLampAnimation();
    }

    neonLampAnimation = () => {
        const container = this.el.querySelector('.neon-effect-images');
        const images = Array.from(container.querySelectorAll('img')).sort((a, b) => Number(a.getAttribute('data-temperature')) - Number(b.getAttribute('data-temperature')));

        function getRandom(min, max) {
            return Math.random() * (max - min) + min;
        }

        const flickerDuration = 0.05;
        const flickerOpacity = 0.85;
        const lightDuration = 0.05;
        const switchDelayRange= { min: 2, max: 5 };
        const switchRepeatRange = { min: 1, max: 6 };

        const flicker = gsap.fromTo(container, {
            opacity: 1,
        }, {
            opacity: flickerOpacity,
            duration: flickerDuration,
            repeat: -1,
            yoyo: true,
            ease: "none"
        });

        const imageProbabilities = images.map(img => Number(img.getAttribute('data-temperature')));
        const totalProbability = imageProbabilities.reduce((a, b) => a + b, 0);

        const switchImages = () => {
            let randomValue = Math.random() * totalProbability;
            let selectedImageIndex;

            for (let i = 0; i < imageProbabilities.length; i++) {
                randomValue -= imageProbabilities[i];

                if (randomValue < 0) {
                    selectedImageIndex = i;
                    break;
                }
            }

            let repeat = Math.round(getRandom(switchRepeatRange.min, switchRepeatRange.max));
            repeat = repeat % 2 === 0 ? repeat : repeat + 1;
            images.forEach((img, index) => {
                gsap.to(img, {
                    opacity: index === selectedImageIndex ? 1 : 0,
                    duration: lightDuration,
                    yoyo: true,
                    ease: "power1.inOut",
                    repeat: repeat,
                });
            });

            setTimeout(switchImages, getRandom(switchDelayRange.min, switchDelayRange.max) * 1000);  // Set a new timer with a new random delay
        }

        switchImages();  // Switch images at the start
    }
}

export default HeroA16ZLive;
